// extracted by mini-css-extract-plugin
export var planCard = "_vf-0";
export var planList = "_vf-1";